<ap-panel type="secondary">
    <div ap-panel-body>
        <h2>{{ 'interest-overview.appointment.header' | apContent }}</h2>

        <p>{{ 'interest-overview.appointment.body' | apContent }}</p>
        <ap-button-link data-testid="appointment-btn" variant="primary" [href]="getAppointmentUrl()" apAnalyticsClick>{{
            'interest-overview.button.appointment.text' | apContent
        }}</ap-button-link>
        <ap-button-link data-testid="max-mortgage-btn" variant="secondary" [href]="getMaxMortgageUrl()" apAnalyticsClick>{{
            'interest-overview.button.max-mortgage.text' | apContent
        }}</ap-button-link>
    </div>
</ap-panel>
